import { ArrowRightLeft } from 'lucide-react';
import { HO } from '../lib/i18nHandover';
import { flyTo } from '../lib/vis';

const fmt = (t) => (t ? new Date(t).toLocaleString() : '–');
function Item({ T, i }) {
  const extra = [i.fields?.length && i.fields.map((f) => T.field[f] || f).join(', '), i.media > 0 && T.photos.replace('{n}', i.media), i.memos > 0 && T.memos.replace('{n}', i.memos)].filter(Boolean).join(' · ');
  return (
    <button type="button" className="ho-item" data-testid={`ho-item-${i.act}`} disabled={!i.ll} onClick={() => i.ll && flyTo([i.ll], true)}>
      <span className={`ho-tag ${i.act}`}>{T.act[i.act]}</span>
      <span><b>{T.kind[i.kind]}</b> {i.name}{extra && <small className="muted"> · {extra}</small>}</span>
    </button>
  );
}

// handover note: what changed in the field since the PC version; choice take (PC version backed up) / copy / cancel
export function HandoverDiff({ diff, onDone }) {
  const T = HO[document.documentElement.lang] || HO.en, s = diff.sum, list = diff.items.slice(0, 200);
  return (
    <div className="ask-backdrop" data-testid="handover-dialog">
      <div className="ask-box" role="dialog" style={{ maxWidth: 560, width: 'calc(100vw - 24px)' }}>
        <b><ArrowRightLeft size={16} /> {T.title}</b>
        <p data-testid="handover-intro">{T.intro.replace('{o}', fmt(diff.oldAt)).replace('{n}', fmt(diff.newAt))}</p>
        <p data-testid="handover-sum"><b>{diff.items.length ? T.sum.replace('{a}', s.new).replace('{c}', s.chg).replace('{d}', s.del).replace('{m}', s.media) : T.none}</b></p>
        {diff.newAt && diff.oldAt && diff.newAt < diff.oldAt && <p className="aq-dry" data-testid="handover-older">{T.older}</p>}
        <div className="ho-list" data-testid="handover-list">{list.map((i) => <Item key={`${i.kind}${i.id}`} T={T} i={i} />)}{diff.items.length > 200 && <small>{T.more.replace('{n}', diff.items.length - 200)}</small>}</div>
        <div className="ask-row">
          <button type="button" className="btn btn-outline" data-testid="handover-cancel" onClick={() => onDone('cancel')}>{T.cancel}</button>
          <button type="button" className="btn btn-outline" data-testid="handover-copy" onClick={() => onDone('copy')}>{T.copy}</button>
          <button type="button" className="btn btn-green" data-testid="handover-take" onClick={() => onDone('take')}>{T.take}</button>
        </div>
      </div>
    </div>
  );
}
